<template>
    <div class="md info-card">
        <div class="caption">
            <div class="name">{{ caption }}</div>
            <slot name="top"></slot>
        </div>
        <div class="info-list">
            <ul v-if="list.length">
                <li
                    v-for="item in list"
                    :key="JSON.stringify(item)"
                    :class="[item.block? 'is-block': '',item.alert? 'is-alert': '', ,item.align? 'is-'+ item.align: '']"
                >
                    <div class="key">{{ item.key }}</div>
                    <div class="value">{{ item.value }}</div>
                </li>
            </ul>
            <slot name="list"></slot>
        </div>
        <slot name="bottom"></slot>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        props: {
            caption: {
                type: String,
                require: false,
                default: ''
            },
            list: {
                type: Array,
                require: false,
                default: function(){
                    return []
                }
            },
        },
        computed: {
            ...mapState([
                'user',
            ])
        },
    }
</script>

<style scoped lang="scss">

    .is-danger {
        $type: map-get($colors, 'danger');
        $text: map-get($type, 'text');

        color: $text;
    }

    .md.info-card {
        border: $border;
        border-radius: $border-radius;
        padding-bottom: $interval-m;
        background-color: $white;

        //animation slide-in and slide-out to shorten the length of summary
        &.slide-in {

            .info-list {

                ul {
                    opacity: 1;
                    visibility: visible;
                    -webkit-transition: max-height $transition ease-in-out, opacity $transition linear, visibility $transition linear;
                    transition: max-height $transition ease-in-out, opacity $transition linear, visibility $transition linear;                   
                }
            }
        }

        &.slide-out {

            .info-list {

               ul {
                    max-height: 0;
                    opacity: 0;
                    visibility: hidden;
                    -webkit-transition: max-height $transition ease-in-out, opacity $transition linear, visibility $transition linear;
                    transition: max-height $transition ease-in-out, opacity $transition linear, visibility $transition linear;
                    
                    li {
    
                        &.is-block{
                            padding: 0;
                        }
                    }
               }
            }
        }
       
        .caption {
            $size: 32px;

            position: relative;
            padding: $interval-m $interval-l;
            padding-right: $interval-l + $size;
            background-color: $major-color;
            color: $white;
            font-size: $font-size-xl;
            border-radius: $border-radius $border-radius 0 0;

            .name {
                line-height: $size;
            }

            .func {

                .extend {
                    position: absolute;
                    top: $interval-m;
                    right: $interval-xxl;
                    cursor: pointer;
                    height: $size;
                    width: $size;
                    line-height: $size;
                    line-height: $size;
                    font-size: $font-size-m;
                    text-align: center;
                }

                a {
                    position: absolute;
                    top: $interval-m;
                    right: $interval-m;
                    cursor: pointer;
                    transition: $transition;
                    background-color: $white;
                    border-radius: $border-radius;
                    color: $major-color;

                    &.is-font {
                        padding: 0 $interval-m;
                        font-size: $font-size-s;

                        &::before {
                            width: auto;
                            font-size: $font-size-l;
                            margin-right: $interval-xs;
                            vertical-align: -3px;
                        }
                    }

                    &:hover {
                        opacity: $opacity-h;
                    }

                    &::before {
                        @extend %font-pseudo;
                        display: inline-block;
                        height: $size;
                        width: $size;
                        line-height: $size;
                        text-align: center;
                        vertical-align: middle;
                    }

                    &.is-edit, &.is-add {

                        &::before {
                            content: '\e3c9';
                        }
                    }

                    &.is-remove {

                        &::before {
                            content: '\e872';
                        }
                    }

                    &.is-save {

                        &::before {
                            content: '\e161';
                        }
                    }

                    &.is-alert {

                        &::before {
                            content: '\e000';
                        }
                    }

                    &.is-open{

                        &::before{
                            content:'\e5cc';
                        }
                    }
                }

                // right arrow direction

                &.is-active{

                    a{

                        &.is-open{

                            &::before{
                                content: '\e5cf';
                            }
                        }
                    }
                }
            }
        }

        .info-list {
            padding: 0 $interval-l;

            ul {
                @extend %reset;
            }

            li {
                display: flex;

                @include media('mobile') {
                    display: block;
                }

                &.is-alert {

                    .value {
                        $type: map-get($colors, 'danger');
                        $text: map-get($type, 'text');

                        color: $text;

                        &::before {
                            @extend %font-pseudo;
                            position: relative;
                            content: '\e001';
                            margin-right: $interval-xs;
                            color: $text;
                            vertical-align: bottom;
                        }
                    }
                }

                &.is-block {
                    display: block;
                    padding-bottom: $interval-m;

                    .value {
                        // border-radius: $border-radius;
                        background-color: #ECECEC;
                    }

                    // .bar {
                    //     background-color: #ECECEC;
                    //     height: 36px;
                    //     position: relative;
                    //     margin: 20px 10px;
                    //     padding: $interval-s;
                    //     border-radius: $border-radius;
                    //     .box {
                    //         height: 100%;
                    //         overflow: hidden;
                    //         .percentage {
                    //             background-color: #B9E4F8;
                    //             height: 100%;
                    //             border-radius: $border-radius;
                    //         }
                    //     }
                        

                    //     ul.legend {
                    //         position: absolute;
                    //         top: 0;
                    //         left: 0;
                    //         bottom: 0;
                    //         right: 0;
                    //         li.label {
                    //             display: inline-block;
                    //             position: absolute;
                    //             border-left: 1px solid #FCFCFC;
                    //             top: 0;
                    //             bottom: 0;

                    //             .level, .rate {
                    //                 text-decoration: none;
                    //                 position: absolute;
                    //                 font-size: $font-size-xs;
                    //                 left: -10px;
                    //             }

                    //             .level {
                    //                 bottom: 46px;
                    //             }

                    //             .rate {
                    //                 top: 46px;
                    //             }


                    //             .dot {
                    //                 display: inline-block;
                    //                 text-decoration: none;
                    //                 position: absolute;
                    //                 top: 66px;
                    //                 left: -2px;
                    //                 border: 2px solid #000;
                    //                 border-radius: 50%;
                    //             }
                    //         }
                    //     }
                    // }

                    // .input {
                    //     width: 100%;
                    // }
                }

                &.is-input {
                    display: block;

                    .value {
                        padding: 0;
                        padding-bottom: $interval-m;

                        .cp.input.textarea {
                            margin: 0;
                        }

                        .cp.input.input {
                            margin: 0;
                        }
                    }
                }

                &.is-left {
                    text-align: left;
                }

                &.is-right {
                    text-align: right;
                }

                + li {
                    border-top: $border;
                }

                +.label {
                    border: none;
                }
            }

            .key {
                padding: $interval-m;
                flex: 1;
                display: flex;
                align-items: center;

                @include media('mobile') {
                    padding-bottom: 0;
                    
                }

                .color {
                    color: $major-color;
                    font-size: $font-size-xl;

                    @each $key, $map in $colors {
                        $tx: map-get($map, 'text');

                        &.is-#{$key} {
                            color: $tx !important;
                        }
                    }

                    @include media('mobile') {
                        font-size: $font-size-m;
                    }
                }
            }

            .value {
                padding: $interval-m;
                min-height: 24px;
            }
        }
    }
</style>
